const properPriceSetter = (price, salesRatio = 0.9) => {
  const discountedPrice = price * salesRatio // 할인 가격 계산
  const roundedPrice = Math.floor(discountedPrice / 100) * 100 // 가격을 100단위로 반올림
  return roundedPrice
}
export default properPriceSetter
